module.exports = __webpack_public_path__ + "img/overall-icon.a8e7b711.svg";